import { fs } from "./firebase";
// import { socket } from '../socket';

const FIRESTORE_REALTIME_COLLECTION_NAME = "rt_subscriptions_by_users";
export const Topics = {
  MESSAGE: "message",
  MESSAGES: "messages",
  CLEARANCE_TRACKS: "cltracks",
  CLEARANCE_FORMS: "clforms",
  ACTIVITY_REPORTS: "actreports",
};

export function subscribe(parameters, onNotification) {

  let docPath = parameters.userId 
                ? parameters.userId + "__" + parameters.type + "__" + parameters.topic
                : parameters.groupId 
                ? parameters.groupId + "__" + parameters.type + "__" + parameters.topic 
                : parameters.topic

  // =====
  // console.log(">>>docPath", docPath);
  // socket.on(docPath, (data)=>{
  //   console.log(">>>data", data);
  //   if(!parameters.topic.includes('message')){
  //     onNotification(data);
  //   }
  //   else{
  //     onNotification();
  //   }
  // });
  // =====
  return fs.collection(FIRESTORE_REALTIME_COLLECTION_NAME)
  .doc(docPath)
  .onSnapshot(
    (docSnapshot) => {
      let param = null;
        if(!parameters.topic.includes('message')){
          fs.collection(FIRESTORE_REALTIME_COLLECTION_NAME).where("type", "==", parameters.topic).limit(1).get()
          .then((querySnapshot)=>{
            querySnapshot.forEach((doc) => {
              param = doc.data();
              onNotification(param);
            });
          })
        }
        else{
          onNotification();
        }
          
      },
      (err) => {
        console.log(`[subscribe] Encountered error: ${err}`);
      }
    );
}

export function unsubscribe(parameters) {
  fs.collection(FIRESTORE_REALTIME_COLLECTION_NAME)
    // .doc(parameters.userId + "__" + parameters.topic)
    .doc(parameters.userId + "__" + "user" + "__" + parameters.topic)
    .onSnapshot(() => {});
}